import declare from "dojo/_base/declare";
import PostRequest from "csi/comm/PostRequest";
import { FIELD_DOCUMENT_TEMPLATE } from "./DGaaSSelectTemplate";
import { FIELD_OUTPUT_TYPE } from "./DGaaSSelectTemplate";
import xml from "csi/xml";
import New from "csi/table/New";
import Response from "csi/comm/JsonResponse";
import { addToFileUploadMap } from "./main";

const DGaaSSelectTemplateController = declare(New, {
	/**
	 * @override
	 * Set the parameters to the call method DocumentGenerator NewDocumentTemplate
	 */
	process() {
		const fd = this.getFormData();
		const docContainerURL = this.m_urlParent;
		const dGaaSTemplateURL = fd.getFieldValue(FIELD_DOCUMENT_TEMPLATE);

		const req = new PostRequest("DocumentGenerator", "GenerateDocumentFromTemplate");
		req.addParameter("DocumentType", fd.getFieldValue(FIELD_OUTPUT_TYPE));
		req.addParameter("DGaaSTemplate", dGaaSTemplateURL);
		req.addParameter("ParentURL", docContainerURL);
		req.addParameter("DocumentName", fd.getFieldValue(xml.ATTR_NAME));
		this.waitForPublish(req.post());
	},

	/**
	 * @override
	 * Retrieves the newly created document and adds it to the browserStore map.
	 * This is necessary to display a ToolTip on the document's File attribute 
	 * in case the document generation needs to be canceled.
	 */
	onPublishResponse(response: Response): void {
		const cache = this.getCache();
		addToFileUploadMap(response.getResultNode(), cache);
	},

	/**
	 * @override
	 * Return newly created Document
	 */
	getNewNodes() {
		this.inherited(arguments);
		return this.m_response.getNodesOfType("Document");
	},

	/**
	 * @override
	 * When we create a Document by selecting DGaaSTemplate and Doc type
	 * Hide the Save & Go button on the form
	 */
	_canNavigate(): boolean {
		return false;
	},
});
export = DGaaSSelectTemplateController;